import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    outline: 0;
    padding: 0;
    font-family: 'Roboto';
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  html, body, #__next {
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  button {
    border: none;
    background: none;
    font-weight: bold;
    cursor: pointer;
  }

  #__next {
    z-index: 0;
    > main {
      height: 100%;
    }
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  ::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #1e1e1e;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;

  border: 2px solid #1e1e1e;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

html {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

  #portal-root {
    overflow: hidden;
  }
`;
